var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel',{ref:"currentRef",attrs:{"controls":"","interval":0}},_vm._l((_vm.slideOptions),function(item,index){return _c('b-carousel-slide',{key:index,attrs:{"img-src":_vm.$helpers.imageHelper(item)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }